import { render, staticRenderFns } from "./ExcButton.vue?vue&type=template&id=772d616c&scoped=true&"
import script from "./ExcButton.vue?vue&type=script&lang=ts&"
export * from "./ExcButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExcButton.vue?vue&type=style&index=0&id=772d616c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d616c",
  null
  
)

export default component.exports